var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNetSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 86,
    viewBox: "0 0 85 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.872314,
    width: 84.2553,
    height: 84.2553,
    fill: "#B4B3E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7026 34.5856H65.4348V54.3015H61.8159V34.5856H55.5634V31.3539H71.7026V34.5856ZM54.3012 54.3015H42.0577V31.3539H53.8161V34.5856H45.6767V41.0855H53.1761V44.3015H45.6767V51.0881H54.3012V54.3015ZM37.2655 54.3015H33.3088L22.8913 37.4342C22.6307 37.0144 22.4112 36.5692 22.2361 36.105H22.1446C22.2259 36.5976 22.2665 37.6479 22.2665 39.2585V54.3015H18.7695V31.3539H22.9827L33.0523 47.8251C33.4764 48.5053 33.7507 48.9771 33.8726 49.2325H33.9335C33.8319 48.6252 33.7811 47.5932 33.7811 46.1441V31.3513H37.2655V54.3015ZM15.1633 52.4954C15.1633 52.7794 15.1062 53.0605 14.9952 53.3228C14.8843 53.5851 14.7217 53.8234 14.5167 54.024C14.3117 54.2247 14.0684 54.3838 13.8007 54.4922C13.533 54.6007 13.246 54.6563 12.9563 54.656C12.6666 54.656 12.3798 54.6 12.1121 54.4913C11.8445 54.3825 11.6014 54.2232 11.3967 54.0222C11.1919 53.8213 11.0296 53.5829 10.919 53.3204C10.8084 53.058 10.7516 52.7768 10.752 52.4928C10.7527 51.9203 10.9852 51.3714 11.3985 50.9668C11.8119 50.5622 12.3722 50.3349 12.9563 50.3349C13.246 50.3346 13.533 50.3902 13.8007 50.4986C14.0684 50.6071 14.3117 50.7662 14.5167 50.9668C14.7217 51.1675 14.8843 51.4058 14.9952 51.6681C15.1062 51.9303 15.1633 52.2115 15.1633 52.4954Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetSvg);
export default __webpack_public_path__ + "static/media/netSvg.42155700b2c56795fd76b02ca5429afc.svg";
export { ForwardRef as ReactComponent };